module.exports = __webpack_public_path__ + "static/media/thumb_4.c5e3783a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_4.png
// module id = 80
// module chunks = 0